import { fetcher } from "helpers/fetcher";

import { TGetBUDetailRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getBUDetail = async (buId: string, language?: string) => {
  return await fetcher<TGetBUDetailRes, any>(ENDPOINT.BU.GET_BU_DETAIL, {
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.BU.GET_BU_DETAIL.version,
      [API_HEADER.LANGUAGE]: language,
      [API_HEADER.BU_ID]: buId,
      [API_HEADER.BLOCK_404]: true,
    },
  });
};

export const queryGetBUDetail = async (buId: string, language?: string) => {
  return (await getBUDetail(buId, language)).data;
};

queryGetBUDetail._key = (buId: string, language?: string) => [
  ENDPOINT.BU.GET_BU_DETAIL.url,
  buId,
  language,
];
